// Utilitários para lidar com datas e timezone de Portugal

/**
 * Converte uma data do input date para o formato correto considerando o timezone de Portugal
 * Evita o problema de a data "voltar um dia" devido ao UTC
 * @param {string} dateValue - Valor do input date (YYYY-MM-DD)
 * @returns {string} - Data no formato YYYY-MM-DD ajustada para Portugal
 */
export const formatDateForPortugal = (dateValue) => {
  if (!dateValue) return '';
  
  // Simplesmente retorna a data como está, sem conversões de timezone
  // O input type="date" já fornece o formato correto YYYY-MM-DD
  return dateValue;
};

/**
 * Converte uma data vinda do backend para exibição considerando o timezone de Portugal
 * @param {string} dateString - Data em formato ISO do backend (YYYY-MM-DD)
 * @returns {string} - Data formatada para exibição (dd/mm/yyyy)
 */
export const formatDateForDisplay = (dateString) => {
  if (!dateString) return '';
  
  // Extrair apenas a parte da data (YYYY-MM-DD) e converter para formato português
  const dateOnly = dateString.split('T')[0]; // Remove parte do horário se existir
  const [year, month, day] = dateOnly.split('-');
  
  // Retornar no formato dd/mm/yyyy
  return `${day}/${month}/${year}`;
};

/**
 * Converte uma data do backend para o formato do input date
 * @param {string} dateString - Data em formato ISO do backend
 * @returns {string} - Data no formato YYYY-MM-DD para input
 */
export const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  
  // Extrair apenas a parte da data (YYYY-MM-DD)
  return dateString.split('T')[0];
};

/**
 * Obter a data atual no timezone de Portugal para inputs
 * @returns {string} - Data atual no formato YYYY-MM-DD
 */
export const getTodayInPortugal = () => {
  const now = new Date();
  const portugalTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Lisbon' }));
  
  const year = portugalTime.getFullYear();
  const month = String(portugalTime.getMonth() + 1).padStart(2, '0');
  const day = String(portugalTime.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};